import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import { URI } from '@fiverr-private/futile';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';

/**
 * Fetch items with pagination.
 */
export const fetchItems = async (type, lastItemId) => {
    const { userId } = getContext();

    const fetchItemsRoute = buildFetchItemsRoute(type, lastItemId);

    try {
        const { data } = await axios.get(fetchItemsRoute);

        return data;
    } catch (error) {
        logger.error(error, { description: 'Failed to fetch collection items', userId });

        throw error;
    }
};

const buildFetchItemsRoute = (type, lastItemId) => {
    const { pathParameters = {} } = getContext();
    const { user_id: username, id: slug } = pathParameters;

    const url = pathfinder('collection_page_users_collections_items_fetch', {
        username,
        slug,
    });

    const fetchItemsRoute = new URI(url).addParams({
        type: type.toLowerCase(),
    });

    if (lastItemId) {
        fetchItemsRoute.addParams({
            last_item_id: lastItemId,
        });
    }

    return fetchItemsRoute.toString();
};
